import { render } from "./EventSetting.vue?vue&type=template&id=30b91326&scoped=true&ts=true"
import script from "./EventSetting.vue?vue&type=script&lang=ts"
export * from "./EventSetting.vue?vue&type=script&lang=ts"

import "./EventSetting.vue?vue&type=style&index=0&id=30b91326&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b91326"]])

export default __exports__